import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=5e3d6df5&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=5e3d6df5&prod&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=5e3d6df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d6df5",
  null
  
)

export default component.exports